import {LaborCategoryInfo, PayCodeType, ProjectLaborCategory, WorkLocationType} from "@app/shared";

export class ChargeCodeInfo {
  id?: number;
  version?: number;
  codeType: string;
  owner;
  ownerId: number;
  parentId: number;
  projectId: number;
  taskId: number;
  payTypeId: number;
  name: string;
  activityDescription: string;
  chargeNumber: string;
  allowCharging: boolean;
  workLocationFromHome: boolean;
  effectiveFrom: string;
  effectiveThru: string;
  authorizedFrom: string;
  authorizedThru: string;
  authorizedHours: number;
  availableHours: number;
  workedHours: number;
  hoursDidNotWork: number;
  payTypeCode: PayCodeType;
  isBillable: boolean;
  projectName: string;
  taskName: string;
  firstName: string;
  lastName: string;

  laborAccountGroupId: number;
  purchaseAccountGroupId: number;
  expenseAccountGroupId: number;
  revenueAccountGroupId: number;
  laborAccountGroupName: string;
  purchaseAccountGroupName: string;
  expenseAccountGroupName: string;

  laborCategory: ProjectLaborCategory;
  laborCategoryInfo: LaborCategoryInfo [];
  // userAddressInfo: UserAddressInfo;
  defaultWorkLocation: WorkLocationType;

  noHourLimit: boolean;
}
